import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import AppAdsPage from './components/AppAdsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/app-ads.txt" element={<AppAdsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
